import { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
// material
import { Avatar, Box, Divider, Typography } from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
import {
  addRecipients,
  onSendMessage,
  getConversation,
  getParticipants,
  markConversationAsRead,
  resetActiveConversation
} from '../../../redux/slices/chat';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
//
import ChatRoom from './ChatRoom';
import ChatMessageList from './ChatMessageList';
import ChatHeaderDetail from './ChatHeaderDetail';
import ChatMessageInput from './ChatMessageInput';
import ChatHeaderCompose from './ChatHeaderCompose';
import Messages from '../user/profile/Messages';
import axios from 'axios';
import { REST_API, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import JobNoteMessageHeader from './JobNoteHeader';
import JobNoteMessageInput from './JobNoteMessageInput';
import JobLogMessageList from './JobLogMessageList';


// ----------------------------------------------------------------------

const conversationSelector = (state) => {
  const { conversations, activeConversationId } = state.chat;
  const conversation = conversations.byId[activeConversationId];
  if (conversation) {
    return conversation;
  }
  return {
    id: null,
    messages: [],
    participants: [],
    unreadMessages: 0
  };
};

export default function JobNoteWindow({ products, allUser,requestIdd, designOrderId, requestDetails,fromDesign,isDesignOrder,renderCards,setRenderCards,fetchRequestDetails, details,accessPublicMessageBoard,convertedDesignRequestId, noteType }) {
  console.log('requestDetails++++++', requestDetails)
  console.log('JobNoteWindow - designOrderId:', designOrderId)
  console.log('JobNoteWindow - isDesignOrder:', isDesignOrder)
  console.log('JobNoteWindow - requestIdd:', requestIdd)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [conversatingUser, setConversatinguser] = useState([])
  console.log('conversatingUser',conversatingUser)
  const { pathname } = useLocation();
  const { conversationKey } = useParams();
  const [conversationMessage, setconversationMesage] = useState([])
  const [clientSideMessage, setClientSideMessage] = useState([])
  const { contacts, recipients, participants, activeConversationId } = useSelector((state) => state.chat);
  console.log('allUser+++++++++++', allUser)
  const conversation = useSelector((state) => conversationSelector(state));
  const mode = conversationKey ? 'DETAIL' : 'COMPOSE';


    const [adminData, setAdminData] = useState(null);
    
    const fetchData = async () =>{
      try{
        const result = await axios.post(`${REST_API_END_POINT}get-admin-data`,{ userId : 1 })
        if(result){
          setAdminData(result.data.adminData)
        }
        else{
          setAdminData(null)
        }
      }
      catch(error){
        console.log('admin data error : ',error);
        setAdminData(null)
      }
    }
  
    useEffect(()=>{
      fetchData();
    },[])

  const displayParticipants = participants.filter((item) => item.id !== '8864c717-587d-472a-929a-8e5f298024da-0');

  let user = JSON.parse(localStorage.getItem('user'))
  const requestId = requestIdd || localStorage.getItem('requestId')
  const userType = user.user_type
  const userId = user.user_id
  const explodedPermissions = user?.exploded_permissions
  useEffect(() => {
    const getDetails = async () => {
      dispatch(getParticipants(conversationKey));
      try {
        dispatch(getConversation(conversationKey));
      } catch (error) {
        console.error(error);
        navigate(PATH_DASHBOARD.chat.new);
      }
    };
    if (conversationKey) {
      getDetails();
    } else if (activeConversationId) {
      dispatch(resetActiveConversation());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationKey]);

  useEffect(() => {
    if (allUser?.length && userId) {
      const initialRecipients = allUser.filter((user) => user.user_id !== userId);
      setConversatinguser(initialRecipients);
    }
  }, [allUser, userId]);

  useEffect(() => {
    if (activeConversationId) {
      dispatch(markConversationAsRead(activeConversationId));
    }
  }, [dispatch, activeConversationId]);

  const handleAddRecipient = (recipient) => {
    console.log('recipienttttttt',recipient)
    setConversatinguser(recipient)
  };
 
    const viewJobNoteMessage = async (value) => {
    try {
  const partnerId =
      value?.sender_id ||
      value?.id ||
      (Array.isArray(conversatingUser) && conversatingUser.length > 0 ? conversatingUser[0].id : null);
      
      // Determine from_status based on noteType prop
      let fromStatus;
      if (noteType === "design") {
        fromStatus = 1; // Design notes
      } else if (noteType === "job") {
        fromStatus = 2; // Job notes
      } else {
        // Fallback to original logic
        fromStatus = fromDesign ? 1 : 2;
      }
      
      const data = {
        partnerId,
         userId: userId, 
         requestId: isDesignOrder ? null : requestId,
         designOrderId: designOrderId || null,
        userType: userType,
        from_status: fromStatus
      }
      
      console.log('viewJobNoteMessage - data being sent:', data)
  
      const res = await axios.post(`${REST_API}webservice/request/view-job-note-message`, data)
      if (res.data) {
          
          if(userType!==3){
            setconversationMesage(res?.data?.message)
          }else{
            setClientSideMessage(res?.data?.message)
          }
      }
    } catch (error) {
      console.log(error, 'error in view message in admin side')
    }

  }


    const handleSendMessage = async (value) => {
    try {
      console.log(value,'----------------value when type -1')
      const res = await axios.post(`${REST_API}webservice/request/sent-job-note-message`, value)

      if (res.data.status == 1) {
        viewJobNoteMessage(null)

      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleSendAdminMsg = async (value) => {
   console.log(value, '$$$$$$$$$$$$$$$$')
    try {
      const res = await axios.post(`${REST_API}webservice/request/sent-job-note-message`, value)

      if (res.data.status == 1) {
        viewJobNoteMessage()
      }
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    viewJobNoteMessage()
  }, [])

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
      {/* {userType == 1 || (explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request','Add vendor to request','Add client to request'].includes(permission)))? ( */}
        <>
          <JobNoteMessageHeader
            contactss={conversatingUser}
            recipients={recipients}
            contacts={Object.values(contacts.byId)}
            onAddRecipient={handleAddRecipient}
            adminData={adminData}
          />
          <Divider />
        </>
      {/* // ) : (
      //   <>
       
      //     <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 3, marginY: 2 }}>
      //       <Box sx={{ position: 'relative' }}>
      //         <Avatar src={requestDetails.pic} alt={requestDetails.send_to} />
      //       </Box>
      //       <Box sx={{ ml: 2 }}>
      //         <Typography variant="subtitle2">{requestDetails.send_to}</Typography>
      //       </Box>
      //     </Box>
      //     <Divider />
      //   </>
      // )} */}

      <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
          <JobLogMessageList
            isDesignOrder={isDesignOrder}
            conversationMessage={(userType != 3) ? conversationMessage : clientSideMessage}
            handleFetchData={()=>viewJobNoteMessage((userType === 3) ? requestDetails : conversatingUser )}
            conversation={conversation}
            products={products}
            setRenderCards={setRenderCards}
            renderCards={renderCards}
            fetchRequestDetails={fetchRequestDetails}
            details={details}
            allMembers={allUser}
            />
          {/* <Messages/> */}

          <Divider />


          <JobNoteMessageInput
            addedBy={requestDetails?.added_by}
            conversatingUser={conversatingUser}
            conversationId={conversationKey}
            // onSend={userType == 1 ? handleSendMessage : handleSendAdminMsg}
            onSend={handleSendMessage}
            adminData={adminData}
            disabled={pathname === PATH_DASHBOARD.client.chat}
            fromDesign={fromDesign}
            requestIdd={isDesignOrder ? null : requestId}
            designOrderId={designOrderId || null}
            isDesignOrder={isDesignOrder}
            convertedDesignRequestId={convertedDesignRequestId}
            noteType={noteType}
          />

        </Box>
      </Box>
    </Box>
  );
}
